import React, { useState, useEffect } from "react";
import "./Checkout.css";
import ProductCard from "./ProductCard";
import BillingAddress from "./BillingAddress";
import arrow from "../../../assets/images/arrow.png";
import plus from "../../../assets/images/plus.png";
import { useHistory } from "../../../app-services/lib/router-compat";
import CircularProgress from "@mui/material/CircularProgress";
import SaveForLater from "./SaveForLater";
import SavedBook from "./Savedbook";
import { CartItemSkeleton, CartSummarySkeleton } from "./CheckoutSkeleton";
const Checkout = (props) => {
  const history = useHistory();
  const [cartDetails, setcartDetails] = useState([]);
  const [saveLater, setSaveLater] = useState([]);
  const [savedBook, setSavedBook] = useState([]);
  const [loading, setLoading] = useState("none");
  // First cart fetch shows skeletons; later refreshes keep the spinner
  const [cartLoaded, setCartLoaded] = useState(false);
  useEffect(() => {
    getCartDetails();
    getAllSaveForLaterDetails();
    getAllPromotionList();
    // ProductCard's "Save For Later" button gates on
    // api.checkSubscribeUser(), which reads store.user.savedBookCount and
    // store.user.subscription — but nothing on this page ever refreshed
    // those, so the check ran against whatever was left over from
    // wherever the user was before landing on the cart page (stale, or
    // still undefined this session). That's why the block could fire
    // inconsistently — sometimes on the very first "Save For Later"
    // click, even with only 1-2 items actually saved. Refresh it here so
    // the limit check always has this session's real count by the time
    // the user can click anything on this page.
    mixins.reFectchSavedBookDetails(props);
    localStorage.setItem("editmode", false);
    mixins.setStore("fulladdress", {}, props);
    mixins.setStore("contrywithgst", {}, props);
    mixins.setStore("gstamount", "", props);
    mixins.setStore("book.worldbookPreInfo", {}, props);
    mixins.setStore("parentblob", "", props);
    mixins.setStore("childblob", "", props);
  }, []);
  const getCartDetails = () => {
    setLoading("flex");
    api
      .getCartDetails()
      .finally(() => setCartLoaded(true))
      .then((res) => {
        setLoading("none");
        if (res && res.statusCode === 200 && res.data) {
          //console.log("Cartmessage", res);
          setcartDetails(res.data);
          mixins.setStore("cartItem", res.data.totalNumberOfBooks, props);
          mixins.setStore("cart_list", res.data, props);
        }
      });
  };
  const getAllSaveForLaterDetails = () => {
    api.getAllSaveforLater().then((res) => {
      if (res && res.statusCode === 200 && res.data) {
        let respData = res.data.saveForLater;
        let respData2 = res.data.savedBooks;
        // console.log(respData);
        setSaveLater(respData);
        setSavedBook(respData2);
        mixins.setStore("seaveforlaterCount", res.data.length, props);
      }
    });
  };
  const getAllPromotionList = () => {
    api.getPromotionList().then((res) => {
      if (res && res.statusCode === 200 && res.data) {
        mixins.setStore("PromotionList", res.data, props);
      }
    });
  };
  return (
    <div className="Checkout">
      <div className="checkout-container container">
        <div className="item-col">
          <div className="cart">
            <div className="cart-count">
              Your Cart ( {cartDetails && cartDetails.totalNumberOfBooks} ) |{" "}
              <span>
                CONTINUE SHOPPING <img src={arrow} className="img" />
              </span>
            </div>
            <div
              className="add-new"
              onClick={() => {
                history.push("/");
              }}
            >
              <img src={plus} className="img-plus" />
              ADD NEW BOOK
            </div>
          </div>
          {cartLoaded && (
            <div style={{ display: loading, margin: "auto" }}>
              <CircularProgress color="success" />
            </div>
          )}
          {!cartLoaded ? (
            <CartItemSkeleton />
          ) : cartDetails &&
            cartDetails.cart &&
            cartDetails.cart.length >= 1 ? (
            cartDetails.cart &&
            cartDetails.cart.map((item, index) => {
              return (
                <ProductCard
                  item={item}
                  key={index}
                  getCartDetails={getCartDetails}
                  getAllSaveForLaterDetails={getAllSaveForLaterDetails}
                />
              );
            })
          ) : (
            <div className="cart-empty">Your Cart is Empty</div>
          )}
        </div>
        <div className="bill-col">
          {cartLoaded ? (
            <BillingAddress props={cartDetails} />
          ) : (
            <CartSummarySkeleton />
          )}
        </div>
      </div>
      <div className="save-later-div">
        {saveLater &&
          saveLater &&
          saveLater.length >= 1 &&
          saveLater.length >= 1 && <div className="title">Save For later</div>}
        {saveLater &&
          saveLater &&
          saveLater.length >= 1 &&
          saveLater.map((item, index) => {
            return (
              <SaveForLater
                item={item}
                key={index}
                getCartDetails={getCartDetails}
                getAllSaveForLaterDetails={getAllSaveForLaterDetails}
              />
            );
          })}
      </div>
      <div className="save-later-div">
        {savedBook && props.store.user && savedBook.length >= 1 && (
          <div className="title">Saved Books</div>
        )}
        {savedBook &&
          props.store.user &&
          savedBook.length >= 1 &&
          savedBook.map((item, index) => {
            return (
              <SavedBook
                item={item}
                key={index}
                getCartDetails={getCartDetails}
                getAllSaveForLaterDetails={getAllSaveForLaterDetails}
              />
            );
          })}
      </div>
    </div>
  );
};
export default connect(Checkout);
